import mHelper from '../../config/Helper';
var isLogin = JSON.parse(mHelper.GET_COOKIES('login_portal'));

class DisputeControllers {

    GET_SELECT_DISPUTE = (id,callback) => {
        fetch(mHelper.URL_API() + "/dispute/" + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    UPDATE_DISPUTE_DATA = (id,row,callback) => {
        fetch(mHelper.URL_API() + "/dispute/update/"+id, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify(row)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    ADD_DISPUTE_DRAFT = (periode,ad_code,ad_name,type_trx,callback) => {
        fetch(mHelper.URL_API() + "/dispute/create-draft", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                periode: periode,
                ad_code:ad_code,
                ad_name: ad_name,
                type_trx: type_trx
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DATA_DISPUTE = (filter, callback) => {
        var infoFilter = JSON.stringify(filter);
        fetch(mHelper.URL_API() + "dispute?filter=" + infoFilter, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) =>  response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DATA_BAR = (filter, callback) => {
        fetch(mHelper.URL_API() + "/dispute/bar-recon" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify(filter)
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DETAIL_DISPUTE = (id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/detail/"+id , {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            }
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    ADD_DETAIL_DISPUTE = (dealer_code,sales_fee,qty_trx,dispute_id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/add-detail" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dealer_code : dealer_code,
                sales_fee: sales_fee,
                qty_trx: qty_trx,
                dispute_id: dispute_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    UPDATE_DETAIL_DISPUTE = (dispute_det_id,dealer_code,sales_fee,qty_trx,dispute_id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/update-detail" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dispute_det_id : dispute_det_id,
                dealer_code:dealer_code,
                sales_fee: sales_fee,
                qty_trx: qty_trx,
                dispute_id: dispute_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    DELETE_DETAIL_DISPUTE = (dispute_det_id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/delete-detail" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dispute_det_id : dispute_det_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DETAIL_DISPUTE_SELECT = (dispute_det_id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/detail_by_id/"+dispute_det_id , {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            }
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    DELETE_DISPUTE = (dispute_id, callback) => {
        fetch(mHelper.URL_API() + "/dispute/delete" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dispute_id : dispute_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    
    SUBMIT_DISPUTE = (dispute_id, callback) =>{
        fetch(mHelper.URL_API() + "/dispute/submit" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dispute_id : dispute_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    RESET_TRX_DISPUTE = (dispute_id, callback) =>{
        fetch(mHelper.URL_API() + "/dispute/reset_trx_dispute" , {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
            body:JSON.stringify({
                dispute_id : dispute_id
            })
        })
        .then((response) => response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

    GET_DEALER = (filter, callback) => {
        var infoFilter = JSON.stringify(filter);
        fetch(mHelper.URL_API() + "/dispute/dealer?filter=" + infoFilter, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + isLogin.token
            },
        })
        .then((response) =>  response.json())
        .then((responseJson) => {
            callback(responseJson);
        })
        .catch((error) => {
            console.error(error);
        });
    }

}


const mDisputeControllers = new DisputeControllers();
export default mDisputeControllers;
